// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { useDebouncedCallback } from "@coreui/react-pro";
import axios from "axios";
import { useContext, useState } from "react";
import { AuthContext } from "../contexts/auth-context";
import getEnv from "../tools/get-env";

const API_URL = "https://api.mapbox.com/search/geocode/v6/forward";

const useMapbox = ({ types = [], country = ["gb", "ie"] }) => {
  const API_KEY = getEnv("MAPBOX_API_KEY");
  const [results, setResults] = useState([]);
  const [rawResults, setRawResults] = useState([]);
  const [error, setError] = useState({});
  const [attribution, setAttribution] = useState("");

  const { user } = useContext(AuthContext);

  const formResponse = (features) =>
    features.map((feature) => ({
      id: feature.id,
      full_address: feature.properties.full_address,
      line1: feature.properties.name,
      line2: feature.properties.context.locality?.name ?? "",
      locality: feature.properties.context.place?.name ?? "",
      region: feature.properties.context.district?.name ?? "",
      country: feature.properties.context?.country?.name ?? "",
      postcode: feature.properties.context?.postcode?.name ?? "",
      longitude: feature.properties.coordinates.longitude ?? 0,
      latitude: feature.properties.coordinates.latitude ?? 0,
      feature_type: feature.properties.feature_type,
    }));

  const search = useDebouncedCallback(async (q, countryOld = ["gb", "ie"], bounds = []) => {
    if (q && q.length > 0) {
      let params = {
        access_token: API_KEY,
        q,
      };

      if (types && types.length > 0) {
        params = {
          ...params,
          types: types.join(","),
        };
      }
      if (bounds && bounds.length > 0) {
        params = {
          ...params,
          bbox: bounds.join(","),
        };
      }
      if (country && country.length > 0) {
        params = {
          ...params,
          country: country.join(","),
        };
      }
      try {
        const { data } = await axios.get(API_URL, {
          headers: {
            Accept: "application/json",
          },
          params,
        });
        setResults(formResponse(data.features));
        setRawResults(data.features);
        setAttribution(data.attribution);
      } catch (e) {
        setError({
          message: e.message,
          code: e.code,
          status: e.response?.status ?? 418,
        });
        setResults([]);
        setRawResults([]);
      }
    } else {
      setResults([]);
      setRawResults([]);
    }
  }, 500);

  return {
    search,
    results,
    rawResults,
    error,
    attribution,
  };
};

export default useMapbox;
